<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div slot="header">
                    <h3>
                        <feather-icon icon-pack="feather-icon" icon="UserIcon"></feather-icon>
                        All Users
                    </h3>
                </div>
                <vs-button @click="$router.push({name:'users-add'})" class="float-left" style="margin-top: 17px;margin-left: 1%;" icon-pack="feather" icon="icon-plus" color="primary" type="filled">Add New</vs-button>
                <vs-button @click="handleDelete" class="float-left" style="margin-top: 17px;margin-left: 1%;" icon-pack="feather" icon="icon-trash" v-if="selected.length > 0" color="danger" type="filled">Delete {{selected.length}} Rows</vs-button>
                <vs-input icon-pack="feather" icon="icon-search" label-placeholder="Search" v-model="search" class="is-label-placeholder float-right"/>
                <div class="el-table">
                    <data-tables-server @sort-change="sortChange" @query-change="fetchData" :loading="loader" :data="data">
                        <el-table-column>
                            <template scope="scope">
                                <vs-checkbox v-model="selected" :vs-value="scope.row"></vs-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="id" label="ID#"></el-table-column>
                        <el-table-column align="center" sortable prop="username" label="Username"></el-table-column>
                        <el-table-column align="center" sortable prop="token" label="Token"></el-table-column>
                        <el-table-column align="center" sortable prop="company_name" label="Company Name"></el-table-column>
                        <el-table-column align="center" sortable prop="status" label="Status"></el-table-column>
                        <el-table-column align="center" sortable prop="from" label="From"></el-table-column>
                        <el-table-column align="center" sortable prop="to" label="to"></el-table-column>
                        <el-table-column align="center" sortable prop="created_at" label="Created At"></el-table-column>
                        <el-table-column align="center">
                            <template scope="scope">
                                <vs-button class="options" size="small" icon-pack="feather" icon="icon-edit" color="primary" @click="handleEdit(scope.$index,scope.row)" type="filled">Edit</vs-button>
                                <vs-button class="options" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="handleDelete(scope.$index, scope.row)" type="filled">Delete</vs-button>
                            </template>
                        </el-table-column>
                    </data-tables-server>
                    <div style="padding: 15px;" align="center">
                        <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" @size-change="handleSizeChange" :total="total" :current-page="page" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                    </div>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>

</template>


<script>

    import Configs from '../../config.js';

    export default {
        data() {
            return {
                popupActiveDetails: false,
                selected: [],
                data: [],
                search: '',
                page: null,
                total: null,
                pageSize: null,
                loader: false,
                prop: null,
                sort: null,
                showed_data: null,
                dialogRow:null
            }
        },
        mounted() {
            this.fetchData();
        },
        created() {
            this.setBreadCrumbsItems();
        },
        watch: {
            search: function () {
                this.fetchData();
            }
        },
        methods: {
            handleEdit(index, row) {
                localStorage.setItem("saved_object", JSON.stringify(row));
                this.$router.push({name: "users-edit"});
            },
            sortChange(sortProps) {
                this.headerClick(sortProps.column, event)
            },
            headerClick(column, event) {
                this.prop = column.property;
                this.sort = column.order;
            },
            handleDelete(index = null, row = null) {
                this.dialogRow = row;
                this.$vs.dialog({
                    color: 'danger',
                    title: `Are you sure?`,
                    text: 'you will not able to retrieve this records',
                    accept: this.sendDelete,
                })
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.fetchData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.fetchData();
            },
            sendDelete(row) {
                this.loader = true;
                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/users/delete',
                    data: {rows: (this.dialogRow ? [this.dialogRow] : this.selected),},
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    this.fetchData();
                    this.loader = false;
                    this.selected = [];
                    this.dialogRow = null;
                    this.$vs.notify({title: 'Great', text: 'You successfully deleted interface(s)', color: 'success', iconPack: 'feather', icon: 'icon-check'});
                }).catch((err) => {
                    console.log(err.response);
                    this.loader = false;
                })
            },
            fetchData() {
                this.loader = true;
                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/users/get-users',
                    data: {
                        page: this.page,
                        pageSize: this.pageSize,
                        search: this.search,
                        sort: this.sort,
                        prop: this.prop
                    },
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    this.total = response.data.total;
                    this.data = response.data.data;
                    this.loader = false;
                }).catch((err) => {
                    console.log(err.response);
                    this.loader = false;
                })
            },
            setBreadCrumbsItems() {
                let items = [
                    {
                        title: 'Users',
                    },
                    {
                        title: 'Show All Users',
                        active: true
                    }
                ];
                this.$store.commit("SetBreadCrumbsItems", items)
            }
        }
    }
</script>

<style>
    .pagination-bar {
        display: none;
    }

    pre {
        background: #1a1a1a;
        border: 1px solid #ddd;
        border-left: 3px solid #3554f3;
        color: #b8a460;
        page-break-inside: avoid;
        font-family: monospace;
        font-size: 15px;
        line-height: 1.6;
        margin-bottom: 1.6em;
        max-width: 100%;
        overflow: auto;
        padding: 1em 1.5em;
        display: block;
        word-wrap: break-word;
    }

    .options {
        margin: 1px !important;
        display: inline-flex !important;
    }

    .con-vs-popup .vs-popup {
        width: 1200px;
    }
</style>